<template>
	<div>
		<app-inbox-loading v-if="isDataLoading" />
		<div v-else>
			<b-row>
				<b-col v-if="false">
					<b-button class="btn-close-page float-right mb-2" @click="$emit('closePage')" v-b-tooltip.hover title="Close"><b-icon-x /></b-button>
					<b-button class="btn-close-page float-right mb-2 mr-2" @click="$emit('approvalFlow')" v-b-tooltip.hover title="Approval History"><b-icon icon="clock-history" /></b-button>
				</b-col>
			</b-row>
			<b-card header="Finish Good Quality Inspection Approval" class="mb-3">
				<b-row>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" label-cols-lg="12" label="Control Card" id="fieldset-control-card" size="sm" :model.sync="model.controlCardId"   :selected="model.controlCard != null ? model.controlCard.controlCardNumber : ''" @input="getControlCards" @change="updateData" :isEditable="false" :isSelectMethodExists="true" @onSelectMethod="setSelectedControlCard" :isUpdatable="true"/>
						<app-input-textbox id="fieldset-qty-before" label-cols-lg="12" label="Qty Before" label-for="input-qty-before" size="sm" :model.sync="model.qtyBefore"  @change="updateData" :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-qty-after" label-cols-lg="12" label="Qty After" label-for="input-qty-after" size="sm" :model.sync="model.qtyAfter"  @change="updateData" :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-qty-pending" label-cols-lg="12" label="Qty Pending" label-for="input-qty-pending" size="sm" :model.sync="model.qtyPending"  @change="updateData" :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-qty-ng" label-cols-lg="12" label="Qty Ng" label-for="input-qty-ng" size="sm" :model.sync="model.qtyNg"  @change="updateData" :isEditable="false" :isUpdatable="true" />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-radio :options="metodeQcs" text-field="name" value-field="id" label-cols-lg="12" label="Metode Qc" id="fieldset-metode-qc" size="sm" :model.sync="model.metodeQcId"  @change="updateData" :isEditable="false" :isUpdatable="true" />
						<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-lg="12" label="Part" id="fieldset-part" size="sm" :model.sync="model.partId"   :selected="model.part != null ? model.part.partNumber : ''" @input="getParts" @change="updateData" :isEditable="false" :isSelectMethodExists="true" @onSelectMethod="setSelectedPart" :isUpdatable="true"/>
						<app-input-combobox-autocomplete :options="workOrderProcessDetails" optionsLabel="part" optionsKey="id" label-cols-lg="12" label="Work Order Process Detail" id="fieldset-work-order-process-detail" size="sm" :model.sync="model.workOrderProcessDetailId"   :selected="model.workOrderProcessDetail != null ? model.workOrderProcessDetail.part : ''" @input="getWorkOrderProcessDetails" @change="updateData" :isEditable="false" :isSelectMethodExists="true" @onSelectMethod="setSelectedWorkOrderProcessDetail" :isUpdatable="true"/>
					</b-col>
				</b-row>
			</b-card>

		<app-table-input-popup title="Finish Good Quality Inspection NG" :bordered="true" :items="finishGoodQualityInspectNgInboxs" :fields="fieldsFinishGoodQualityInspectNgInbox" :busy="isDataLoading" :sort-by.sync="sortByFinishGoodQualityInspectNgInbox" :sort-desc.sync="sortDescFinishGoodQualityInspectNgInbox" small responsive
			@editButtonMethod="editRowDataFinishGoodQualityInspectNgInbox"
			@deleteButtonMethod="deleteRowDataFinishGoodQualityInspectNgInbox"
			@showPopupAddMethod="resetDataFinishGoodQualityInspectNgInbox()"
			@showPopupUploadMethod="showPopupUploadFinishGoodQualityInspectNgInbox()"
			@downloadMethod="downloadFinishGoodQualityInspectNgInbox()"
			@addFromClipboardMethod="addFromClipboardFinishGoodQualityInspectNgInbox()"
			@replaceFromClipboardMethod="replaceFromClipboardFinishGoodQualityInspectNgInbox()"
			:showActionButton="false"
			:showEditButton="false"
			:showDeleteButton="false"
			:showAddButton="false"
			:showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false"
			:showUploadButton="false"
			:showDownloadButton="false"
			:isDownloadBusy="isDownloadFinishGoodQualityInspectNgInbox"
			>
			<template #top-row v-if="isShowFinishGoodQualityInspectNgInboxFilter">
				<b-th></b-th>
				<b-th></b-th>
							<b-th stacked-heading="Problem Category">
								<v-select append-to-body label="code" :options="problemCategorys"  :value="filterFinishGoodQualityInspectNgInbox.problemCategoryId" :reduce="item => item.id" v-model="filterFinishGoodQualityInspectNgInbox.problemCategoryId" @search="getProblemCategorys" :filterable="true"></v-select>
							</b-th>
							<b-th stacked-heading="QtyNg">
								<b-form-input id="input-qty-ng-table" v-model="filterFinishGoodQualityInspectNgInbox.qtyNg" size="sm"></b-form-input>
							</b-th>

				<b-th></b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( finishGoodQualityInspectNgInboxPageSize * (currentFinishGoodQualityInspectNgInboxPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
						<template v-slot:cell(problemCategory)="row">
							{{ row.item != null ? row.item.problemCategory != null ? row.item.problemCategory.code : "" : "" }}
						</template>
						<template v-slot:cell(finishGoodQualityInspectInbox)="row">
							{{ row.item != null ? row.item.finishGoodQualityInspectInbox != null ? row.item.finishGoodQualityInspectInbox.controlCard : "" : "" }}
						</template>

			<template v-slot:form-add-detail>
				<FinishGoodQualityInspectNgInboxInput 
					:openPopup="isShowPopupFinishGoodQualityInspectNgInbox"
					:modelId="finishGoodQualityInspectNgInboxId"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataFinishGoodQualityInspectNgInbox"/>
			</template>
			<template v-slot:upload-detail>
				<FinishGoodQualityInspectNgInboxUpload
					:openPopup="isShowPopupUploadFinishGoodQualityInspectNgInbox"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataFinishGoodQualityInspectNgInbox"
					:parentId="modelId"
					/>
			</template>

		</app-table-input-popup>
			<b-overlay :show="isBusy" no-wrap></b-overlay>
			<Portal to="app-inbox-button">
				<app-approval-button
					@approveMethod="editRequestAction" 
					:showApproveButton="true" 
					approveButtonTitle="Edit Request"
					:showRejectButton="false"
					:showRevisionButton="false"
					/>
			</Portal>
		</div>
	</div>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import FinishGoodQualityInspectInbox from '@/models/FinishGoodQualityInspectInbox/FinishGoodQualityInspectInbox';
import FinishGoodQualityInspectInboxList from '@/models/FinishGoodQualityInspectInbox/FinishGoodQualityInspectInboxList';
import FinishGoodQualityInspectInboxFilter from '@/filters/FinishGoodQualityInspectInbox/FinishGoodQualityInspectInboxFilter';

import AppInputTextarea from '@/components/AppInputTextarea';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputRadio from '@/components/AppInputRadio';
import MetodeQc from '@/models/MetodeQc/MetodeQc';
import MetodeQcFilter from '@/filters/MetodeQc/MetodeQcFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import WorkOrderProcessDetail from '@/models/WorkOrderProcess/WorkOrderProcessDetail';
import WorkOrderProcessDetailFilter from '@/filters/WorkOrderProcess/WorkOrderProcessDetailFilter';
import FinishGoodQualityInspectNgInbox from '@/models/FinishGoodQualityInspectInbox/FinishGoodQualityInspectNgInbox';
import FinishGoodQualityInspectNgInboxFilter from '@/filters/FinishGoodQualityInspectInbox/FinishGoodQualityInspectNgInboxFilter';
import ProblemCategory from '@/models/ProblemCategory/ProblemCategory';
import ProblemCategoryFilter from '@/filters/ProblemCategory/ProblemCategoryFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import FinishGoodQualityInspectNgInboxInput from '@/views/FinishGoodQualityInspectInbox/FinishGoodQualityInspectNgInboxInput';
import FinishGoodQualityInspectNgInboxUpload from '@/views/FinishGoodQualityInspectInbox/FinishGoodQualityInspectNgInboxUpload';

import PopupRouterView from '@/components/PopupRouterView';
import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';
import PopupRouterViewApprovalDetail from '@/components/PopupRouterViewApprovalDetail';
import AppApprovalButton from '@/components/AppApprovalButton';

export default {
	props: 
		{
			selectedModelId: {
				default: "",
				type: String
			},
			selectedModel: {
				default: null,
				type: Object
			},
			successAction: {},
			inboxType: {
				default: "",
				type: String
			}
		}
	,
	components : {
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		AppInputRadio,
		FinishGoodQualityInspectNgInboxInput,
		FinishGoodQualityInspectNgInboxUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewApprovalDetail, 
		PopupRouterView,
		AppApprovalButton,
		AppInputTextarea,

		PopupRouterViewApprovalDetail, 
		PopupRouterViewDetail,
		PopupRouterView,
		AppApprovalButton,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		}
	},

	data() {
		return {
			errorMessage : {
			},

			datas: Array(),
			selectAll: false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			isShowDataDetailFilter: false,
			isDownloadDataDetail: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			backroute: '',
			approvalConfiguration: {},
			fieldsFinishGoodQualityInspectNgInbox: [
				//{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"problemCategory": { "class" : "th-problem-category first-child", "label" : "Problem Category", key: 'problemCategory', sortable: true }}, 
				{"qtyNg": { "class" : "th-qty-ng", "label" : "QtyNg", key: 'qtyNg', sortable: true }}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			modelFinishGoodQualityInspectNgInbox : {},
			isShowPopupFinishGoodQualityInspectNgInbox : false,
			isShowPopupUploadFinishGoodQualityInspectNgInbox : false,
			filterFinishGoodQualityInspectInbox : null,
			currentFinishGoodQualityInspectInboxPage : 1,
			finishGoodQualityInspectInboxPageSize: 10,
			sortByFinishGoodQualityInspectInbox: '',
			sortDescFinishGoodQualityInspectInbox: '',
			filterFinishGoodQualityInspectNgInbox : null,
			currentFinishGoodQualityInspectNgInboxPage : 1,
			finishGoodQualityInspectNgInboxPageSize: 10,
			sortByFinishGoodQualityInspectNgInbox: '',
			sortDescFinishGoodQualityInspectNgInbox: '',
			sortingByFinishGoodQualityInspectNgInbox: [],
			finishGoodQualityInspectNgInboxs : [],
			finishGoodQualityInspectNgInboxId : '',
			totalFinishGoodQualityInspectNgInboxRow : 0,
			isShowFinishGoodQualityInspectNgInboxFilter: false,
			isDownloadFinishGoodQualityInspectNgInbox: false,
			problemCategorys: [],
			controlCards: [],
			controlCards: [],
			isControlCardComboLoading: false,
			metodeQcs: [],
			metodeQcs: [],
			isMetodeQcComboLoading: false,
			parts: [],
			parts: [],
			isPartComboLoading: false,
			workOrderProcessDetails: [],
			workOrderProcessDetails: [],
			isWorkOrderProcessDetailComboLoading: false,
			backroute: '',
			isControlCardComboLoading: false,
			isMetodeQcComboLoading: false,
			isPartComboLoading: false,
			isWorkOrderProcessDetailComboLoading: false,
			isProblemCategoryComboLoading: false,
			isFinishGoodQualityInspectInboxComboLoading: false,

		}
	},
	methods : {
		getFinishGoodQualityInspectInbox : async function(id) {
			this.isDataLoading = true;
			this.getFinishGoodQualityInspectNgInboxs();

			
			FinishGoodQualityInspectInbox.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				//FinishGoodQualityInspectInbox.getApprovalConfigurationInput(this, result.approvalInstanceId).then(result => { this.approvalConfiguration = result; this.isDataLoading = false; }).catch(() => { this.isDataLoading = false; });
				this.isDataLoading = false;
			}).catch(error => { this.isDataLoading = false; });
		},
		downloadData() {
			this.isDownloadFinishGoodQualityInspectInbox = true;
			this.filterFinishGoodQualityInspectInbox.id = this.modelId;
			FinishGoodQualityInspectInbox.downloadDataDetail(this, this.filterFinishGoodQualityInspectInbox).then(result => {
				this.isDownloadFinishGoodQualityInspectInbox = false;
			}).catch(error => { this.isDownloadFinishGoodQualityInspectInbox = false; })
		},
		getFinishGoodQualityInspectNgInboxs : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterFinishGoodQualityInspectNgInbox);
			if (this.modelId == null) return;
			filter.finishGoodQualityInspectInboxId = this.modelId;
			//filter.draftMode = "0";
			if (this.sortByFinishGoodQualityInspectNgInbox != null) {
				this.sortingByFinishGoodQualityInspectNgInbox[this.sortByFinishGoodQualityInspectNgInbox] = this.sortDescFinishGoodQualityInspectNgInbox;
			}
			let currentPage = (this.currentFinishGoodQualityInspectNgInboxPage - 1);
			if (isAddRow) {
				let totalData = this.totalFinishGoodQualityInspectNgInboxRow + 1;
				let page = Math.ceil(totalData/this.finishGoodQualityInspectNgInboxPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.finishGoodQualityInspectNgInboxPageSize = 0;
			// disable paging end
			FinishGoodQualityInspectNgInbox.getList(this, filter, this.sortingByFinishGoodQualityInspectNgInbox, currentPage , this.finishGoodQualityInspectNgInboxPageSize).then(result => {
				this.currentFinishGoodQualityInspectNgInboxPage = currentPage + 1;
				this.finishGoodQualityInspectNgInboxs = result.data;
				this.totalFinishGoodQualityInspectNgInboxRow = result.dataCount;
			}).catch(error => {});
		},
		getProblemCategorys : async function(input) {
			let filter = new ProblemCategoryFilter();
			if (input != undefined) {
				filter.code = input;
			}
			this.isProblemCategoryComboLoading = true;
			ProblemCategory.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.problemCategorys = result.data
				}
				this.isProblemCategoryComboLoading = false;
			})
			.catch(error => {});
		},
		getFinishGoodQualityInspectInboxs : async function(input) {
			let filter = new FinishGoodQualityInspectInboxFilter();
			if (input != undefined) {
				filter.controlCard = input;
			}
			this.isFinishGoodQualityInspectInboxComboLoading = true;
			FinishGoodQualityInspectInbox.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.finishGoodQualityInspectInboxs = result.data
				}
				this.isFinishGoodQualityInspectInboxComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedControlCard(item) {
			if(item == undefined || item == null) {
				this.model.controlCardId = null;
				this.model.controlCard = null;
			} else {
				this.model.controlCardId = item.id;
				this.model.controlCard = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getMetodeQcs : async function(input) {
			let filter = new MetodeQcFilter();
			if (input != undefined) {
				filter.name = input;
			}
			MetodeQc.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.metodeQcs = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedMetodeQc(item) {
			if(item == undefined || item == null) {
				this.model.metodeQcId = null;
				this.model.metodeQc = null;
			} else {
				this.model.metodeQcId = item.id;
				this.model.metodeQc = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedPart(item) {
			if(item == undefined || item == null) {
				this.model.partId = null;
				this.model.part = null;
			} else {
				this.model.partId = item.id;
				this.model.part = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getWorkOrderProcessDetails : async function(input) {
			let filter = new WorkOrderProcessDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}
			WorkOrderProcessDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderProcessDetails = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedWorkOrderProcessDetail(item) {
			if(item == undefined || item == null) {
				this.model.workOrderProcessDetailId = null;
				this.model.workOrderProcessDetail = null;
			} else {
				this.model.workOrderProcessDetailId = item.id;
				this.model.workOrderProcessDetail = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;

			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					FinishGoodQualityInspectInbox.updateData(this, model, id);
				}
			});
		},

		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					FinishGoodQualityInspectInbox.updateData(this, model, id);
				}
			});
		},
		editDraftAction(modelEvent) {
			let id = this.modelId;
			if(id != '' && id != null && id != undefined) {
				this.$router.push({ name: 'finishgoodqualityinspectinboxcreateinboxrequest', params : { id: id } });
			}
		},
		submitAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				this.isBusy = true;
				FinishGoodQualityInspectInbox.submitApprovalData(this, model, id).then(result => {
					this.isDataCommited = true;
					this.$emit("successAction");
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		approveAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to approve this request?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
							this.isBusy = true;
							FinishGoodQualityInspectInbox.approveApprovalData(this, model, id).then(result => {
								this.isDataCommited = true;
								this.$emit("successAction");
								this.isBusy = false;
							}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		rejectAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to reject this request?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
							this.isBusy = true;
							FinishGoodQualityInspectInbox.rejectApprovalData(this, model, id).then(result => {
								this.isDataCommited = true;
								this.$emit("successAction");
								this.isBusy = false;
							}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		reviseAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to ask for revision for this request?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
							this.isBusy = true;
							FinishGoodQualityInspectInbox.reviseApprovalData(this, model, id).then(result => {
								this.isDataCommited = true;
								this.$emit("successAction");
								this.isBusy = false;
							}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		editRequestAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				this.isBusy = true;
				FinishGoodQualityInspectInbox.editRequest(this, id).then(result => {
					if (result != null) {
						if (result.id != null && result.id != "") {
							this.$router.push({ name: 'finishgoodqualityinspectinboxcreateinboxrequest', params : { id: result.id } });
						}
					}
					this.isCreateBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		discardAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to discard this data?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
						this.isBusy = true;
						FinishGoodQualityInspectInbox.discardData(this, id).then(result => {
							this.isDataCommited = true;
							this.$emit("successAction");
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		resubmitAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				this.isBusy = true;
				FinishGoodQualityInspectInbox.resubmitApprovalData(this, model, id).then(result => {
					this.isDataCommited = true;
					this.$emit("successAction");
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		cancelAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to cancel this request?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
						this.isBusy = true;
						FinishGoodQualityInspectInbox.cancelApprovalData(this, model, id).then(result => {
							this.isDataCommited = true;
							this.$emit("successAction");
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		onHidden() {
			// this.getFinishGoodQualityInspectInboxs();
		},
		addRowDataFinishGoodQualityInspectNgInbox(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.finishGoodQualityInspectInboxId =  this.modelId;
					FinishGoodQualityInspectNgInbox.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getFinishGoodQualityInspectNgInboxs(true);
						this.isShowPopupFinishGoodQualityInspectNgInbox = false;
					})
				} else {
					model.finishGoodQualityInspectInboxId =  this.modelId;
					FinishGoodQualityInspectNgInbox.createData(this, model)
					.then(result => {
						this.getFinishGoodQualityInspectNgInboxs(true);
						this.isShowPopupFinishGoodQualityInspectNgInbox = false;
					})
				}
			}
		},
		async editRowDataFinishGoodQualityInspectNgInbox(id) {
			this.finishGoodQualityInspectNgInboxId = id;
			this.isShowPopupFinishGoodQualityInspectNgInbox = true; 
		},
		async deleteRowDataFinishGoodQualityInspectNgInbox(id) {
			FinishGoodQualityInspectNgInbox.deleteData(this, id).then(result => { this.getFinishGoodQualityInspectNgInboxs(); });
		},
		async resetDataFinishGoodQualityInspectNgInbox() {
			this.finishGoodQualityInspectNgInboxId = "";
			this.isShowPopupFinishGoodQualityInspectNgInbox = true;
		},
		async addDataFinishGoodQualityInspectNgInbox() {
			FinishGoodQualityInspectNgInbox.createData(this, { finishGoodQualityInspectInboxId: this.modelId })
			.then(result => {
				this.getFinishGoodQualityInspectNgInboxs(true);
			})
		},
		async addFromClipboardFinishGoodQualityInspectNgInbox() {
			let qtyNgs = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					qtyNgs.push({ qtyNg: item, finishGoodQualityInspectInboxId: this.modelId });
				});
				FinishGoodQualityInspectNgInbox.addFromClipboard(this, qtyNgs).then(result => { this.getFinishGoodQualityInspectNgInboxs() });
			});
		},
		async replaceFromClipboardFinishGoodQualityInspectNgInbox() {
			let qtyNgs = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					qtyNgs.push({ qtyNg: item, finishGoodQualityInspectInboxId: this.modelId });
				});
				FinishGoodQualityInspectNgInbox.replaceFromClipboard(this, qtyNgs).then(result => { this.getFinishGoodQualityInspectNgInboxs() });
			});   
		},
		showPopupUploadFinishGoodQualityInspectNgInbox() {
			this.isShowPopupUploadFinishGoodQualityInspectNgInbox = true;
		},
		uploadDataFinishGoodQualityInspectNgInbox(modalEvent, newDatas) {
			this.isShowPopupUploadFinishGoodQualityInspectNgInbox = false; 
		},
		downloadFinishGoodQualityInspectNgInbox(modalEvent) {
			this.isDownloadFinishGoodQualityInspectNgInbox = true;
			this.filterFinishGoodQualityInspectNgInbox.finishGoodQualityInspectInboxId = this.modelId;
			FinishGoodQualityInspectNgInbox.downloadDataDetail(this, this.filterFinishGoodQualityInspectNgInbox).then(result => {
				this.isDownloadFinishGoodQualityInspectNgInbox = false;
			}).catch(error => { this.isDownloadFinishGoodQualityInspectNgInbox = false; })
		},
		saveInputFinishGoodQualityInspectNgInbox(item) {
			FinishGoodQualityInspectNgInbox.updateDataDetail(this, item, item.id);
		},

		resetModal(modalType) {
			this.isShowPopupUploadFinishGoodQualityInspectNgInbox = false; 
			this.isShowPopupFinishGoodQualityInspectNgInbox = false; 
			if (modalType == 'FinishGoodQualityInspectNgInbox') {
				this.getFinishGoodQualityInspectNgInboxs();
			}

			//this.showPopupCopyData = false; 
			//this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				this.isShowFinishGoodQualityInspectNgInboxFilter = true;

			}
		},
	},
	beforeMount() {
		//this.filterFinishGoodQualityInspectInbox = new FinishGoodQualityInspectInboxFilter();
//this.filterFinishGoodQualityInspectInbox = new FinishGoodQualityInspectInboxFilter();
		this.filterFinishGoodQualityInspectNgInbox = new FinishGoodQualityInspectNgInboxFilter();
		//this.getProblemCategorys();
		//this.getFinishGoodQualityInspectInboxs();
		//this.getControlCards();
		//this.getMetodeQcs();
		//this.getParts();
		//this.getWorkOrderProcessDetails();


		//this.getFinishGoodQualityInspectInboxs();
	},
	async mounted() {
		if (this.selectedModel != null && this.selectedModel != "") {
			this.modelId = this.selectedModel.id;
			this.model = this.selectedModel;
			this.getDataDetails();
		} else if (this.selectedModelId != null && this.selectedModelId != "") {
			this.modelId = this.selectedModelId;
			this.getFinishGoodQualityInspectInbox(this.selectedModelId);
		}
	},
	computed: {
		disableRejectRevise() {
			if (this.model.approvalRemarks == undefined || this.model.approvalRemarks == null || this.model.approvalRemarks == '') return true;
			return false;
		},
	},
	watch : {
		selectedModelId(newValue, oldValue) {
			if (newValue != oldValue) {
				this.modelId = newValue;
				this.getFinishGoodQualityInspectInbox(newValue);
			}
		},
		selectedModel(newValue, oldValue) {
			if (newValue != oldValue) {
				this.modelId = newValue.id;
				this.model = newValue;
				this.getFinishGoodQualityInspectNgInboxs();
			}
		},
		sortByFinishGoodQualityInspectNgInbox : {
			handler: function() {
				this.getFinishGoodQualityInspectNgInboxs();
			}
		},
		sortDescFinishGoodQualityInspectNgInbox: {
			handler: function() {
				this.getFinishGoodQualityInspectNgInboxs();
			}
		},
		currentFinishGoodQualityInspectNgInboxPage: {
			handler: function() {
				this.getFinishGoodQualityInspectNgInboxs();
			}
		},
		finishGoodQualityInspectNgInboxPageSize : {
			handler: function() {
				this.getFinishGoodQualityInspectNgInboxs();
			}
		},
		filterFinishGoodQualityInspectNgInbox: {
			handler: function() {
				this.getFinishGoodQualityInspectNgInboxs();
			},
			deep: true,
		},


	},
}
</script>
